import React, { useEffect } from 'react';
import {Route, Routes} from 'react-router';
import {createTheme, ThemeProvider} from '@mui/material/styles';

import Navbar from './components/NavBar/NavBar';

import { AnimatePresence } from 'framer-motion';
import Layout from './Layout';
import Home from './pages/Home/Home'
import About  from './pages/About/About';
import News  from './pages/News/News';
import Events from './pages/Events/Events';
import Gallery  from './pages/Gallery/Gallery';
import Collections  from './pages/Collections/Collections';
import Contact from './pages/Contact/Contact';
import Support from './pages/Support/Support';
import Error from "./pages/Error/Error";
import Event from "./pages/Event/Event";
import Theatre from './pages/Theatre/Theatre';
import Training from './pages/Training/Training';
import Bios from './pages/Bios/Bios';
import CommunityService from './pages/CommunityService/CommunityService';
import { Navigate } from "react-router-dom";
import './App.css';

const theme = createTheme({
  palette: {
    background:
    {
      main: "#F2E7E7",
      navbar: "#F5F5F5",
      
    },
    primary: {
      main: "#FF0000",
      red: "#FF0000",
      darkred:"#BB0000",
      black: "#0F0F0F",
      grey: "#999292",
      white: "#ffffff",

    },
    mode: "light",
    action: {
      active: "#efc8b1",
    }
  },
  typography: {
    fontFamily: ["Noto Serif HK", 'serif'].join(','),
    body1: {
      fontWeight: 500,
      color: "#0F0F0F",
    },
    body2: {
      fontWeight: 400,
      color: "#0F0F0F",
    },
    h1: {
      fontWeight: 600,
      color: "#0F0F0F",
    },
    h2: {
      fontWeight: 400,
      color: "#BB0000",
    },
  },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        mobile: 0,
        tablet: 640,
        laptop: 1024,
        desktop: 1200,
      },
    },
  
});

function App()
{
  useEffect(()=>{document.title="Starlight Chinese Opera"},[]);
  return (
    <>
    <ThemeProvider theme={theme}>
      <AnimatePresence mode="wait">
      <Routes>
         <Route path="/" element={<Navigate to="/en" replace />} />
      <Route path="/:lng" element={<Layout />}>
        <Route index element={<Home/>}></Route>
        <Route path="about" element={<About/>}></Route>
        <Route path="news" element={<News/>}></Route>
        <Route path="events" element={<Events/>}></Route>
        <Route path="gallery" element={<Gallery/>}></Route>
        <Route path="collections" element={<Collections/>}></Route>
        <Route path="contact" element={<Contact/>}></Route>
        <Route path="support" element={<Support/>}></Route>
        <Route path="theatre" element={<Theatre/>}></Route>
        <Route path="training" element={<Training/>}></Route>
        <Route path="communityService" element={<CommunityService/>}></Route>
        <Route path="error" element={<Error/>}></Route>
        <Route path="event/:id" element={<Event/>}></Route>
        <Route path="bios/:id" element={<Bios/>}></Route>
        
        </Route>
        <Route path="*" element={<Navigate to="/:lng/error" replace/>} />
        </Routes>
        </AnimatePresence>
      </ThemeProvider>
    </>
  );
}export default App;
